import { render, staticRenderFns } from "./CustomizationHeader.vue?vue&type=template&id=47cbb60c&"
import script from "./CustomizationHeader.vue?vue&type=script&lang=js&"
export * from "./CustomizationHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports